import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ArrowRight, X, Sparkles } from "lucide-react";

const PAGE_CONFIG = {
  "/programs/elite": {
    message: "Fitly Elite — Precision fertility biohacking, online",
    mobileMessage: "Fitly Elite — from ₹12,000/mo",
    ctaText: "Enroll Now",
    ctaHref: "#pricing",
    scrollThreshold: 800,
    isAnchor: true,
  },
  "/programs/premium-plus": {
    message: "Fitly Premium Plus — Conception to Motherhood, ₹85,000",
    mobileMessage: "Premium Plus — ₹85,000",
    ctaText: "Enroll Now",
    ctaHref: "#enroll",
    scrollThreshold: 600,
    isAnchor: true,
  },
  "/": {
    message: "Ready to start your journey? Talk to our fertility nutrition experts today",
    mobileMessage: "Ready to start your journey?",
    ctaText: "Book Consultation",
    ctaHref: "/consultation",
    scrollThreshold: 2200,
    isAnchor: false,
  },
};

const SmartCtaBar = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  const config = PAGE_CONFIG[location.pathname];

  useEffect(() => {
    setDismissed(false);
    setShow(false);
  }, [location.pathname]);

  useEffect(() => {
    if (dismissed || !config) return;

    const check = () => {
      const y = window.scrollY;
      const docH = document.documentElement.scrollHeight;
      const winH = window.innerHeight;
      const pastThreshold = y > config.scrollThreshold;
      const nearBottom = y + winH > docH - 400;
      setShow(pastThreshold && !nearBottom);
    };

    window.addEventListener("scroll", check, { passive: true });
    return () => window.removeEventListener("scroll", check);
  }, [dismissed, config]);

  if (!config || dismissed || !show) return null;

  const handleCtaClick = (e) => {
    if (config.isAnchor) {
      e.preventDefault();
      document.querySelector(config.ctaHref)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 animate-in slide-in-from-bottom duration-400" data-testid="smart-cta-bar">
      <div className="bg-[#0D1F17]/95 backdrop-blur-md border-t border-[#D4AF37]/15 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <Sparkles size={16} className="text-[#D4AF37] flex-shrink-0 hidden sm:block" />
            <p className="text-[#F7F5F0]/80 text-sm hidden sm:block truncate">
              <span className="font-serif italic text-[#F7F5F0]">{config.message}</span>
            </p>
            <p className="text-[#F7F5F0]/80 text-sm sm:hidden font-serif italic">{config.mobileMessage}</p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <a href={config.ctaHref} onClick={handleCtaClick} data-testid="smart-cta-action"
              className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#0D1F17] px-6 py-2 text-sm tracking-wide font-bold hover:bg-[#B5952F] transition-all rounded-full shadow-lg shadow-[#D4AF37]/20">
              {config.ctaText} <ArrowRight size={14} />
            </a>
            <button onClick={() => setDismissed(true)} data-testid="smart-cta-dismiss"
              className="text-[#F7F5F0]/30 hover:text-[#F7F5F0] transition-colors p-1" aria-label="Dismiss">
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartCtaBar;
